import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type StepperState = {
  isStartedInspection: boolean;
  currentStepInspection: number;
  isStartedEmision: boolean;
  currentStepEmission: number;
  isOnPackageSelection: boolean;
  isOnThirdPartyPayment: boolean;
  forcePaymentPage: boolean;
};

export const initialState: StepperState = {
  isStartedInspection: false,
  currentStepInspection: 1,
  isStartedEmision: false,
  currentStepEmission: 0,
  isOnPackageSelection: false,
  isOnThirdPartyPayment: false,
  forcePaymentPage: false,
};

const steppersSlice = createSlice({
  name: 'stepper',
  initialState,
  reducers: {
    overwriteStepper: (
      _,
      action: PayloadAction<StepperState>,
    ): StepperState => {
      return action.payload;
    },
    updateCurrentStepInspection: (
      state,
      action: PayloadAction<number>,
    ): void => {
      state.currentStepInspection = action.payload;
    },
    setIsStartedInspection: (state, action: PayloadAction<boolean>): void => {
      state.isStartedInspection = action.payload;
    },
    updateCurrentStepEmission: (state, action: PayloadAction<number>): void => {
      state.currentStepEmission = action.payload;
    },
    setIsStartedEmission: (state, action: PayloadAction<boolean>): void => {
      state.isStartedEmision = action.payload;
    },
    setIsOnPackageSelection: (state, action: PayloadAction<boolean>): void => {
      state.isOnPackageSelection = action.payload;
    },
    setForcePaymentPage: (state, action: PayloadAction<boolean>): void => {
      state.forcePaymentPage = action.payload;
    },
    updateIsOnThirdPartyPayment: (
      state,
      action: PayloadAction<boolean>,
    ): void => {
      state.isOnThirdPartyPayment = action.payload;
    },
  },
});

export const {
  overwriteStepper,
  updateCurrentStepInspection,
  setIsStartedInspection,
  updateCurrentStepEmission,
  setIsStartedEmission,
  setIsOnPackageSelection,
  updateIsOnThirdPartyPayment,
  setForcePaymentPage,
} = steppersSlice.actions;

export default steppersSlice.reducer;
